/**
@format
@flow
*/
type Data = {
  page: number,
  results: Array<any>,
};

export default function formatPaginatedResults(
  currentData: Data,
  newData: Data,
): Array<any> {
  if (newData.page > currentData.page) {
    return currentData.results.concat(newData.results);
  }

  return newData.results;
}
